import React, { DetailedHTMLProps, InputHTMLAttributes } from 'react';

type CheckboxDefaultProps = Omit<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'type'
>;

export interface CheckboxProps extends CheckboxDefaultProps {
    id?: string;
    name: NonNullable<CheckboxDefaultProps['name']>;
    value: NonNullable<CheckboxDefaultProps['value']>;
    containerClassName?: string;
    label: JSX.Element | string;
}
export default function Checkbox({
    containerClassName,
    label,
    ...props
}: CheckboxProps): JSX.Element {
    const { id, name, value } = props;
    const internalId = id ?? name + '-' + String(value);

    return (
        <div className={containerClassName}>
            <input {...props} type="checkbox" id={internalId} />
            <label htmlFor={internalId}>{label}</label>
        </div>
    );
}
